// action - auth reducer
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const LOGOUT_USER = 'LOGOUT_USER';

// action - view reducer
export const SET_CURRENT_VIEW = 'SET_CURRENT_VIEW';